<template>
  <div>
    <!--xlsx表格导出-->
    <xlsx class="addbut"></xlsx>
    <!-- 添加按钮 -->
    <el-button type="primary" size="mini" class="addbut" @click="centerDialogVisible=true">添加</el-button>
    <!-- <p class="tabletitle"></p> -->
    <el-table
      :data="list"
      border
      size="mini"
      height="650"
      id="out-table"
      :header-cell-style="{background:'#e4f1ff'}"
    >
      <el-table-column type="selection" width="35" reserve-selection :selectable="checkboxInit"></el-table-column>
      <el-table-column prop="uid" label="告警ID"></el-table-column>
      <el-table-column prop="datef" label="操作人员"></el-table-column>
      <el-table-column prop="name" label="设备名称"></el-table-column>
      <el-table-column prop="con" label="信息内容"></el-table-column>
      <el-table-column prop="tlb" label="类型"></el-table-column>
      <el-table-column prop="time" label="时间"></el-table-column>
    </el-table>
    <!--分页组件-->
    <pagination
      :total="total"
      :offset="offset"
      :limit="limit"
      @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges"
    ></pagination>
    <!--弹出层-->
    <el-dialog title="添加报警" :visible.sync="centerDialogVisible" width="40%" center>
      <div class="addconlist">
        <span class="textp">报警名称：</span>
        <el-input
          placeholder="请输入内容"
          class="addinput"
          size="mini"
        ></el-input>
      </div>
      <div class="addconlist">
        <span class="textp">选择设备：</span>
        <el-select
    v-model="input"
    multiple
    collapse-tags
    class="addinput"
    size="mini"
    placeholder="请选择">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
      </div>
      <div class="addconlist">
        <span class="textp">报警方式：</span>
        <el-checkbox-group v-model="checkList" style="display:inline-block;" class="addinput">
        <el-checkbox label="手机"></el-checkbox>
        <el-checkbox label="邮箱"></el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="addconlist">
        <span class="textp">报警联系人：</span>
        <el-select
    v-model="input"
    multiple
    class="addinput"
    size="mini"
    collapse-tags
    placeholder="请选择">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAlarmConfig">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getRealtimeAlarmList } from "@/api/currenttimewarn";
import pagination from "@/components/pagination";
import xlsx from "@/components/xlsx";
export default {
  data() {
    return {
      list: [],
      //分页组件参数
      total: 0,
      offset: 1,
      limit: 10,
      input: "",
      options:[
        {
        label:'111',
        value:'111'
        }
      ],
      centerDialogVisible:false,
      checkList:['手机','邮箱']
    };
  },
  mounted() {
    //获取列表
    getRealtimeAlarmList().then(res => {
      this.list = res.data.data.list;
    })
  },
  components: {
    pagination,
    xlsx
  },
  methods: {
    //分页组件
    SizeChanges(val) {
      console.log(val);
    },
    CurrentChanges(val) {
      console.log(val);
    },
    //搜索框禁止选中
    checkboxInit(row, index) {
      if (index == 0) {
        return 0;
      } else {
        return 1;
      }
    }
  }
};
</script>

<style scoped>
.concen {
  text-align: center;
  margin: 0.5rem auto;
}

.addbut {
  margin: 0.2rem 0.2rem 0.2rem 0rem;
}

.seekright {
  float: right;
}

.rightinput {
  width: 3rem;
  margin: 0.2rem;
}

.addinput {
  display: inline-block;
  width: 4rem;
  margin: 0.2rem;
}

.addselect {
  margin: 0.2rem;
}

.addconlist {
  text-align: center;
}

.tabletitle {
  width: 100%;
  height: 0.8rem;
  font-size: 0.25rem;
  line-height: 0.8rem;
  background-color: #4284da;
  color: #ffffff;
  text-indent: 0.5rem;
}
.textp{
  display: inline-block;
  width: 2.3rem;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  text-align: right;
}
</style>
